import type { RootState } from '~/redux/store';
import type { Role } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<Role> => ({
  sortBy: state.roles.sortBy,
  page: state.roles.page,
  pageSize: state.roles.pageSize,
  with: state.roles.with.join(','),
  ...state.roles.filters,
});

export const getItem = (state: RootState): Role | null => state.roles.item;
